// frontend/src/components/Sidebar.tsx
import React from 'react';
import { Pipette, CircleDot, Trash2, Edit3, MousePointer2, Plus, Minus, Navigation, Droplets } from 'lucide-react';

const Sidebar: React.FC<{onAction: (a: string) => void, role?: string}> = ({ onAction, role }) => {
    const canEdit = role === 'admin' || role === 'designer' || role === "superadmin";
    const canManageSUW = role === 'admin' || role === "superadmin";

    const NavButton = ({ icon: Icon, label, action, color = "white" }: any) => (
        <div className="sidebar-btn-container" onClick={() => onAction(action)}>
            <div className="sidebar-btn">
                <Icon size={20} color={color} strokeWidth={2.5} />
            </div>
            <div className="sidebar-label">{label}</div>
        </div>
    );

    return (
        <div style={{ position: 'absolute', top: '20px', left: '20px', zIndex: 1000 }}>
            <NavButton icon={MousePointer2} label="Wybierz" action="pointer" />

            {canEdit && (
                <>
                    {canManageSUW && (
                        <NavButton icon={Droplets} label="Dodaj SUW" action="drawSUW" color="#10b981" />
                    )}
                    <NavButton icon={Pipette} label="Rysuj rurę" action="drawPolyline" />
                    <NavButton icon={CircleDot} label="Dodaj zawór" action="drawMarker" />
                    <NavButton icon={Edit3} label="Edytuj obiekty" action="edit" />
                    {/* Tekst zmieniony zgodnie z prośbą */}
                    <NavButton icon={Trash2} label="Usuń obiekt" action="delete" color="#ff4d4d" />
                </>
            )}

            <div style={{ marginTop: '20px', paddingTop: '20px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
                <NavButton icon={Plus} label="Przybliż" action="zoomIn" />
                <NavButton icon={Minus} label="Oddal" action="zoomOut" />
            </div>
            <div style={{ marginTop: '10px' }}>
                <NavButton icon={Navigation} label="Moja pozycja" action="locate" color="#3b82f6" />
            </div>
        </div>
    );
};

export default Sidebar;